import axios from "axios";
import { loginAPI } from "../common/api-endpoints";
import { environment } from "../environment";

export const onLogin = () => {
    return axios.post(environment.APIURL +  loginAPI, environment.loginParams);
}